import React from "react";
const Luckysheet = () => {
  const luckyCss = {
    height: "253px",
    width: "100%",
    margin: "0",
    padding: "0",
  };
  return <div id="luckysheet2" style={luckyCss}></div>;
};

export default Luckysheet;
